<div class="relative w-full">

    <div class="flex items-center h-10 w-full rounded-xl border overflow-hidden transition-all duration-200 focus-within:ring-2"
        [ngClass]="hasError()
         ? 'border-red-400 focus-within:ring-red-100'
         : 'border-gray-200 focus-within:border-arena-blue-500 focus-within:ring-arena-blue-100'">

        <button type="button"
            class="flex items-center gap-1.5 h-full pl-3 pr-2.5 bg-gray-50 border-r border-gray-200 shrink-0 transition-colors select-none outline-none"
            [ngClass]="readOnly ? 'cursor-default' : 'cursor-pointer hover:bg-gray-100'" [disabled]="readOnly"
            (click)="!readOnly && toggleDropDown()">
            <span class="text-base leading-none">{{ countryFlag() }}</span>
            <span class="text-sm font-medium text-gray-700 tabular-nums">+{{ selectedPhoneNumber().countryCode }}</span>
            @if (!readOnly) {
            <i class="pi text-[10px] text-gray-400 transition-transform duration-200"
                [ngClass]="isDropDownOpen() ? 'pi-angle-up' : 'pi-angle-down'"></i>
            }
        </button>

        <input type="tel" class="flex-1 h-full px-3 text-sm bg-white outline-none placeholder:text-gray-400 min-w-0"
            [ngClass]="readOnly ? 'text-gray-400 cursor-not-allowed' : 'text-gray-900'" [readOnly]="readOnly"
            [value]="selectedPhoneNumber().contactNumber" placeholder="Phone number" maxlength="15"
            (focus)="isFocused.set(true)" (blur)="isFocused.set(false)" (click)="onTouch()"
            (input)="setPhoneNumber($event)">
    </div>

    @if (isDropDownOpen() && !appendTo) {
    <ng-container [ngTemplateOutlet]="dropdownTemplate" />
    }

</div>

<ng-template #dropdownTemplate>
    <div class="flex flex-col bg-white rounded-xl border border-gray-100 shadow-xl overflow-hidden"
        [ngClass]="{ 'absolute top-full left-0 right-0 mt-1 z-50': !appendTo }"
        [ngStyle]="appendTo ? dropdownStyles() : {}">

        <div class="flex items-center gap-2 px-3 py-2.5 border-b border-gray-100">
            <i class="pi pi-search text-xs text-gray-400 shrink-0"></i>
            <input type="text"
                class="flex-1 text-sm text-gray-900 bg-transparent outline-none placeholder:text-gray-400"
                placeholder="Search country..." autocomplete="off" [value]="searchText()"
                (input)="searchCountry($event)">
        </div>

        <ul class="overflow-y-auto max-h-52 py-1">
            @if (searchDropDownOptions().length) {
            @for (country of searchDropDownOptions(); track country.code) {
            <li class="flex items-center gap-3 px-3 py-2 text-sm cursor-pointer transition-colors" [ngClass]="country.code === selectedPhoneNumber().countryShortName
                ? 'bg-arena-blue-50 text-arena-blue-600'
                : 'text-gray-700 hover:bg-gray-50'" (click)="setCountryCode(country)">
                <span class="text-base leading-none shrink-0">{{ flagEmoji(country.code) }}</span>
                <span class="flex-1 truncate">{{ country.name }}</span>
                <span class="text-xs text-gray-400 shrink-0 tabular-nums">{{ country.phoneCode }}</span>
            </li>
            }
            } @else {
            <li class="px-4 py-6 text-sm text-center text-gray-400">No country found</li>
            }
        </ul>

    </div>
</ng-template>